import { render } from "./GkHeader.vue?vue&type=template&id=d565b426"
import script from "./GkHeader.vue?vue&type=script&lang=js"
export * from "./GkHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__